// 模板管理
export default {
  path: 'template',
  component: () => import('@/layout/Empty.vue'),
  meta: {
    companyVerify: true,
    personVerify: true
  },
  children: [
    {
      path: '/',
      component: () => import('@/views/user/template/templateList/template.vue')
    },
    {
      path: '/templateUse/templateDetail',
      component: () => import('@/views/user/template/templateDetail/templateDetail.vue'),
      meta: {
        title: '模板详情',
        layout: { subPage: true, pageWrap: false }
      }
    },
    {
      name: 'templateUseFill',
      path: '/templateUse/initiator',
      component: () => import('@/views/user/template/templateUse/initiator/initiator.vue'),
      meta: {
        title: '填写模板',
        layout: { subPage: true, pageWrap: false }
      }
    },
    {
      name: 'templateUseParties',
      path: '/templateUse/partiesAdd',
      component: () => import('@/views/user/template/templateUse/partiesAdd/partiesAdd.vue'),
      meta: {
        title: '使用模板',
        layout: { subPage: true, pageWrap: true }
      }
    },
    {
      name: 'templateUseBatchParties',
      path: '/templateUse/batchPartiesAdd',
      component: () => import('@/views/user/template/templateUse/batchPartiesAdd/batchPartiesAdd.vue'),
      meta: {
        title: '使用模板',
        layout: { subPage: true, pageWrap: true }
      }
    }
  ]
}
